var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import BackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Accordion, AccordionSummary, AccordionDetails, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Alert, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataContainerNew } from "../../components/atoms/DataContainer";
import { Delimiter } from "../../components/atoms/Delimiter";
import { Loader } from "../../components/atoms/Loader/Loader";
import { getTemplateTypes } from "../../api";
import { ERoleTypes, getRoleString } from "../../types";
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const TypeDescription = styled.div `
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
`;
const RolesCell = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
const RoleChip = styled(Chip) `
  font-size: 12px !important;
  height: 24px !important;
`;
export function TemplateTypes() {
    const nav = useNavigate();
    const [templateTypes, setTemplateTypes] = useState([]);
    const [isManualAvailable, setIsManualAvailable] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const loadData = () => __awaiter(this, void 0, void 0, function* () {
            try {
                setLoading(true);
                const response = yield getTemplateTypes();
                setTemplateTypes(response.types);
                setIsManualAvailable(response.isManualAvailable);
                setError(null);
            }
            catch (err) {
                console.error("Failed to load template types:", err);
                setError("Не удалось загрузить типы шаблонов");
            }
            finally {
                setLoading(false);
            }
        });
        loadData();
    }, []);
    const onClickBack = () => {
        nav(-1); // Возврат на предыдущую страницу
    };
    const formatRoles = (roles) => {
        return Object.entries(roles).map(([roleKey, count]) => {
            // Пытаемся получить название роли, если roleKey соответствует ERoleTypes
            const roleEnum = ERoleTypes[roleKey];
            const roleName = roleEnum ? getRoleString(roleEnum) : roleKey;
            return (_jsx(RoleChip, { label: `${roleName}: ${count}`, size: "small", variant: "outlined" }, roleKey));
        });
    };
    if (loading) {
        return (_jsx(DataContainerNew, { children: _jsx(Loader, {}) }));
    }
    if (error) {
        return (_jsxs(DataContainerNew, { children: [_jsx(Alert, Object.assign({ severity: "error" }, { children: error })), _jsx(Delimiter, { top: "20px" }), _jsx(Button, Object.assign({ startIcon: _jsx(BackIcon, {}), onClick: onClickBack }, { children: "\u041D\u0430\u0437\u0430\u0434" }))] }));
    }
    return (_jsxs(DataContainerNew, { children: [_jsx(Header, { children: _jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u0422\u0438\u043F\u044B \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432 \u0440\u0430\u0437\u0434\u0430\u0447" })) }), isManualAvailable && (_jsx(_Fragment, { children: _jsx(Alert, Object.assign({ severity: "info", sx: { marginBottom: 2 } }, { children: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0440\u0443\u0447\u043D\u0430\u044F \u0440\u0430\u0437\u0434\u0430\u0447\u0430 \u0440\u043E\u043B\u0435\u0439" })) })), _jsx(Button, Object.assign({ sx: { width: "fit-content", marginBottom: 2 }, startIcon: _jsx(BackIcon, {}), onClick: onClickBack }, { children: "\u041D\u0430\u0437\u0430\u0434" })), _jsx(Delimiter, { top: "20px" }), templateTypes.length === 0 ? (_jsx(Typography, Object.assign({ variant: "body1" }, { children: "\u0422\u0438\u043F\u044B \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }))) : (templateTypes.map((type) => (_jsxs(Accordion, Object.assign({ defaultExpanded: templateTypes.length === 1 }, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(ExpandMoreIcon, {}), "aria-controls": `${type.id}-content`, id: `${type.id}-header` }, { children: _jsxs("div", { children: [_jsx(Typography, Object.assign({ variant: "h6" }, { children: type.name })), _jsxs(Typography, Object.assign({ variant: "caption", color: "textSecondary" }, { children: ["\u0428\u0430\u0431\u043B\u043E\u043D\u043E\u0432: ", type.templates.length] }))] }) })), _jsxs(AccordionDetails, { children: [type.description && (_jsx(TypeDescription, { children: type.description })), type.templates.length === 0 ? (_jsx(Typography, Object.assign({ variant: "body2", color: "textSecondary" }, { children: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0442\u0438\u043F\u0430" }))) : (_jsx(TableContainer, Object.assign({ component: Paper, variant: "outlined" }, { children: _jsxs(Table, Object.assign({ size: "small" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ align: "center" }, { children: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432" })), _jsx(TableCell, { children: "\u0420\u043E\u043B\u0438" }), _jsx(TableCell, Object.assign({ align: "center" }, { children: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442" })), _jsx(TableCell, Object.assign({ align: "center" }, { children: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0439" }))] }) }), _jsx(TableBody, { children: type.templates
                                                .sort((a, b) => b.priority - a.priority) // Сортировка по приоритету
                                                .map((template) => (_jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ align: "center" }, { children: template.playerCount })), _jsx(TableCell, { children: _jsx(RolesCell, { children: formatRoles(template.roles) }) }), _jsx(TableCell, Object.assign({ align: "center" }, { children: template.priority })), _jsx(TableCell, Object.assign({ align: "center" }, { children: template.usageCount }))] }, template.id))) })] })) })))] })] }), type.id))))] }));
}
